
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embed/donate",
      function () {
        return require("private-next-pages/embed/donate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embed/donate"])
      });
    }
  